import StatusDot from '@/components/ui/StatusDot.tsx';
import { BookingSummaryVm } from '@/features/dashboard/bookingChanges/types/BillViewModel.ts';
import { InfoCardRow } from '@/components/ui/InfoCard.tsx';

interface BookingStateStatusRowProps {
  summary: BookingSummaryVm;
}

const BookingStateStatusRow = ({ summary }: BookingStateStatusRowProps) => (
  // „Status”, a nie „Płatności”, czytałoby się jako `BookingStatus`
  // (aktywna/anulowana) — a ten wiersz mówi wyłącznie o rozliczeniu.
  <InfoCardRow divided label="Płatności">
    <StatusDot tone={summary.statusTone} label={summary.statusLabel} />
  </InfoCardRow>
);

export default BookingStateStatusRow;
